import { LitElement, html, css } from '@hh/global.js'

class HHBisNotification extends LitElement {
  static properties = {
    productId: {
      type: String,
      attribute: 'product-id',
    },
    productTitle: {
      type: String,
      attribute: 'product-title',
    },
    variantId: {
      type: String,
      attribute: 'variant-id',
    },
  }

  constructor() {
    super()
    this.currentForm = null
    this.formTranslations = {}
    this.getFormTranslations()
  }

  connectedCallback() {
    super.connectedCallback()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  async getFormTranslations() {
    try {
      const elem = document.querySelector('#bis-form-translations')
      const elemData = JSON.parse(elem?.textContent)
        .replace(/&quot;/g, '"')
        .replace(/=&gt;/g, ':')
      this.formTranslations.stock_notification_form = JSON.parse(elemData)
    } catch (err) {
      console.error('Error capturing Form Translations: ', err)
    }
  }

  handleSubmit(e) {
    e.preventDefault()
    this.currentForm = e.target.form
    const shop = window.Shopify.shop
    const bisUrl = 'https://app.backinstock.org/stock_notification/create.json'
    const formData = new FormData(this.currentForm)
    const url = new URLSearchParams(formData)
    url.append('shop', shop)
    const params = url.toString()
    const newParams = new URL(`${bisUrl}?${params}`)

    this.submitBisForm(newParams)
  }

  async submitBisForm(url) {
    await fetch(url.href)
      .then((res) => res.json())
      .then((data) => {
        this.responseHandler(data)
      })
  }

  responseHandler(data) {
    const responseElem = this.currentForm?.querySelector(
      '.js-bis-response-wrapper'
    )
    const responseText = this.currentForm?.querySelector('.js-bis-response')
    if (data.status === 'OK') {
      responseText.innerText = data.message
      responseElem.classList.add('bis-form--success')
    } else if (data.status === 'Error') {
      responseElem.classList.add('bis-form--error')

      if (data.errors.message) {
        responseText.innerText = data.errors.message
      } else {
        responseText.innerText = data.errors.base[0]
      }
    }
  }

  static styles = css`
    .form-bis__wrapper {
      --hh-slotted-width: 100%;
      position: relative;
      z-index: 2;
      max-width: 38rem;
      background-color: var(--hh-color-day);
      border-radius: 5px;
    }

    @media screen and (min-width: 750px) {
      .form-bis__wrapper {
        max-width: 50rem;
      }
    }

    .form-bis__container {
      padding: 3rem;
    }

    @media screen and (min-width: 750px) {
      .form-bis__container {
        padding: 5rem;
      }
    }

    .form-bis__wrapper .form-bis-notification__title {
      margin: 0;
      padding-bottom: 1.2rem;
      font: var(--hh-h4-font);
      text-align: center;
      line-height: 2.4rem;
      text-transform: none;
      letter-spacing: 0;
      font-size: 2rem;
    }

    @media screen and (min-width: 750px) {
      .form-bis__wrapper .form-bis-notification__title {
        line-height: 3.4rem;
        font-size: 3rem;
      }
    }

    .form-bis__wrapper .form-bis-notification__info {
      margin: 0;
      padding: 1.2rem;
      font-size: 1.2rem;
      text-align: center;
      line-height: 2.2rem;
    }

    @media screen and (min-width: 750px) {
      .form-bis__wrapper .form-bis-notification__info {
        font-size: 1.4rem;
      }
    }

    .form-bis-notification__field label {
      visibility: hidden;
      opacity: 0;
      height: 0;
    }

    .form-bis-notification__input--email {
      display: block;
      height: 42px;
      width: 100%;
      color: var(--hh-color-teal);
      text-align: center;
      padding: 0 2rem;
      border-radius: 0;
      border: 1px solid var(--hh-color-teal);
      z-index: 1;
      box-sizing: border-box;
    }

    .form-bis-notification__btn {
      --hh-max-width: 100%;
      --hh-background: var(--hh-color-gold-2);
      --hh-color: var(--hh-color-day);
      --hh-padding: 0;
      width: 100%;
      margin-top: 1.2rem;
      font-size: 1.4rem;
      min-height: 5.2rem;
    }

    .form-bis-notification__btn:hover {
      --hh-background-hover: var(--hh-color-gold);
    }

    .form-bis-notification__checkbox {
      margin-top: 1em;
    }

    .form-bis-notification__checkbox label {
      --hh-check-top: 6px;
      --hh-width: 1.5rem;
      --hh-height: 1.5rem;
      display: flex;
      align-items: center;
      font-size: 1rem;
      text-transform: uppercase;
      color: var(--hh-color-teal);
    }

    @media screen and (min-width: 750px) {
      .form-bis-notification__checkbox label {
        font-size: 1.2rem;
      }
    }

    .form-bis-notification__checkbox label::before {
      border-radius: 0;
    }

    .form-bis-notification__response {
      margin-top: 1rem;
      border-radius: 3px;
      text-align: center;
    }

    .bis-form--error {
      padding: 0.5rem;
      background-color: var(--hh-color-red-3);
      color: var(--hh-color-red-2);
    }

    .bis-form--success {
      padding: 0.5rem;
      background-color: var(--hh-color-gray-17);
      color: var(--hh-color-green-2);
    }

    .bis-response {
      margin: 0;
      font-size: 1.2rem;
    }
  `

  render() {
    return html`
      <div class="form-bis__wrapper component">
        <div class="form-bis__container">
          <div class="form-bis-notification__header">
            <h4 class="form-bis-notification__title">${this.productTitle}</h1>
            <p class="form-bis-notification__info">${this.formTranslations?.stock_notification_form?.info}</p>
            <slot></slot>
          </div>
          <div class="form-bis-notification__body">
            <form class="form-bis js-form-bis">
              <input type="hidden" name="notification[product_no]" value="${this.productId}">
              <input type="hidden" name="notification[quantity_required]" value="1">
              <input type="hidden" name="variant[variant_no]" value="${this.variantId}">

              <hh-input-wrapper class="form-bis-notification__field" label="stacked" animation="none">
                <input
                  slot='input'
                  type='email'
                  id='bisCustomerEmail--${this.productId}'
                  name='notification[email]'
                  autocomplete='email'
                  autocorrect='off'
                  autocapitalize='off'
                  class='form-bis-notification__input form-bis-notification__input--email'
                  required aria-required='true'
                >
                <label slot='label' for='bisCustomerEmail--${this.productId}'>
                  ${this.formTranslations?.stock_notification_form?.email_placeholder}
                </label>
              </hh-input-wrapper>
              <hh-button-wrapper
                theme="tertiary"
                class="form-bis-notification__action"
              >
                <button @click="${this.handleSubmit}" type="submit" class="btn btn--primary form-bis-notification__btn">
                  ${this.formTranslations?.stock_notification_form?.cta_notify_text}
                </button>
              </hh-button-wrapper>
              <div class="form-bis-notification__response js-bis-response-wrapper">
                <p class="bis-response js-bis-response"></p>
              </div>
              <hh-checkbox-wrapper class="mt1 form-bis-notification__checkbox">
                <input
                  slot='input'
                  type='checkbox'
                  id='bisAcceptMarketing--${this.productId}'
                  name='notification[accepts_marketing]'
                >
                <label slot='label' for='bisAcceptMarketing--${this.productId}'>
                  ${this.formTranslations?.stock_notification_form?.enable_mailing_offer}
                </label>
              </hh-checkbox-wrapper>
            </form>
          </div>
        </div>
      </div>
    `
  }
}

customElements.define('form-bis-notification', HHBisNotification)
